import util from '../../common/util';
import Data, { roleMap } from '../../common/data';
import { popMgr } from '../global';
import {
    setRegisStatus,
    registrationEnum,
    resetRegisStatus
} from './register-track';
import advRegister from './advertising-register/register.js';

import _mixinsRegistry from '@/mixins/register.js';

const styleMap = {
    classic: () =>
        import(
            /* webpackChunkName: "common/sign-log/classic"*/ './classic/index.vue'
        ),
    classicNew: () =>
        import(
            /* webpackChunkName: "common/sign-log/classic-new"*/ './classic-new/index.vue'
        ),
    standard: () =>
        import(
            /* webpackChunkName: "common/sign-log/standard"*/ './standard/index.vue'
        ),
    standardNew: () =>
        import(
            /* webpackChunkName: "common/sign-log/standard-new"*/ './standard-new/index.vue'
        ),
    simpleRegister: () =>
        import(
            /* webpackChunkName: "common/sign-log/simple-register"*/ './simple-register/index.vue'
        ),
    chatRegister: () =>
        import(
            /* webpackChunkName: "common/sign-log/chat-register"*/ './chat-register/index.vue'
        ),
    fashion: () =>
        import(
            /* webpackChunkName: "common/sign-log/fashion"*/ './fashion/index.vue'
        ),
    fashionNew: () =>
        import(
            /* webpackChunkName: "common/sign-log/fashion-new"*/ './fashion-new/index.vue'
        ),
    promotion: () =>
        import(
            /* webpackChunkName: "common/sign-log/promotion"*/ './promotion/index.vue'
        ),
    classicOneStep: () => import('./classic-one-step/index.vue'),
    fashionOneStep: () => import('./fashion-one-step/index.vue'),
    standardOneStep: () => import('./standard-one-step/index.vue'),
    evaluationRegister: () => import('./evaluation-register/index.vue'),
    broker: () => import('./broker/index.vue'),
    brokerNew: () => import('./broker-new/index.vue'),
    brokerOneStep: () => import('./broker-one-step/index.vue'),
    advRegister: () => import('./advertising-register/index.vue')
};
const psMap = {};
// // 记录了打开的注册/登录框实例, 防止重复打开注册登录框
// var current= null;
// function syncPopState(pop){
//     popMgr.setMixin(pop, {
//         watch: {
//             'rootData.popShow': function(value) {
//                 if (!value){
//                     current = null;
//                 }
//             }
//         },
//     })
// }

// when it is previewing in cms.
let fromCmsOptions = {};
window.addEventListener('message', ({ data }) => {
    if (data.action === 'override_popup_options') {
        fromCmsOptions = data.options;
    }
});
const signLog = {
    async authByUrl(vm) {
        // xxx
        let auth = util.getQueryField('facebook_app_auth_data');
        if (!auth) {
            return;
        }
        try {
            let authData = JSON.parse(auth);
            signLog.register(
                vm,
                { facebook_app_auth_data: authData },
                '',
                true,
                false,
                false,
                false
            );
            util.setQueryField({ facebook_app_auth_data: '' }, true);
        } catch (e) {
            console.error('url from facebook_app_auth_data error', e);
        }
    },
    setTackState(isAutoPop, isGoogleOneStep) {
        resetRegisStatus();
        const triggeringEvent = registrationEnum.triggeringEvent;
        const registrationType = registrationEnum.registrationType;
        setRegisStatus({
            triggerEvent: isAutoPop
                ? triggeringEvent.auto
                : triggeringEvent.click
        });
        isGoogleOneStep &&
            setRegisStatus({ registrationType: registrationType.chromeApi });
    },
    prepare(vm, style = Data.registration.style) {
        if (!psMap[style]) {
            psMap[style] = styleMap[style]();
        }
        return psMap[style];
    },
    getFbData(options, style) {
        const styleArr = ['simpleRegister', 'chatRegister'];
        if (
            util.getCookie('_ads_source') === '15' &&
            Data.FBAppId &&
            !styleArr.includes(style)
        ) {
            options.registerClass = 'fb-lead-form';
            options.registerTitle =
                'Want To See Homes Picked Especially For You?';
            options.registerSubTitle = 'Let’s Start!';
        }
    },
    // 正在打开弹窗，解决正在打开的时候，自动弹窗又出来了
    isOpening: false,
    async login(vm, options = {}, style, popReplace = false, action) {
        // 如果当前已经打开了登录或者注册框, 就最直接退出方法
        var cur = popMgr.getCurrent();
        if (!popReplace && (cur?.name === 'sign-log' || signLog.isOpening)) {
            return;
        }
        style = style || Data.registration.style;
        if (Data.leadType) {
            options.role = roleMap[Data.leadType];
        }
        this.getFbData(options, style);
        const vdata = {
            type: 'login',
            name: 'sign-log',
            options: popReplace
                ? options
                : Object.assign(
                      {},
                      Data.registration,
                      { allowClose: true },
                      options,
                      fromCmsOptions
                  )
        };

        try {
            signLog.isOpening = true;
            let pop = await this.prepare(vm, style);
            var ins = popMgr.create(pop.default, vdata, action, true, false);
            await util.sleep(350);
            ins.display(true, false, true);
        } finally {
            signLog.isOpening = false;
        }
    },
    /**
     *
     * @param {*} vm vue根实例
     * @param {*} options
     * @param {*} style
     * @param {*} popReplace
     */
    async register(
        vm,
        options = {},
        style,
        popReplace = false,
        isAutoPop,
        isGoogleOneStep,
        directOpen = true
    ) {
        // 如果当前已经打开了登录或者注册框, 就最直接退出方法
        var cur = popMgr.getCurrent();
        if (!popReplace && (cur?.name === 'sign-log' || signLog.isOpening)) {
            return;
        }
        this.setTackState(isAutoPop, isGoogleOneStep);
        style = style || Data.registration?.style;
        if (
            isAutoPop &&
            Data.registration &&
            Data.registration.autopopup &&
            Data.registration.autopopup.triggerType == 4
        ) {
            // landing page promotion 情况下才有是否可以关闭弹框这个配置项
            style = 'promotion';
            options.allowClose =
                Data.registration.autopopup.allowClose || false;
            options.nameType = Data.registration.autopopup.nameType || 1;
            options.nameRequired =
                Data.registration.autopopup.nameRequired || false;
            options.phoneRequired =
                Data.registration.autopopup.phoneRequired || false;
        }
        if (Data.leadType) {
            options.role = roleMap[Data.leadType];
        }

        // 如果有广告的注册配置就使用广告的注册方式
        if (advRegister.isShow()) {
            style = 'advRegister';
            options.allowClose = options?.mouseLeaveAllowClose || false;
        }

        options.popStyle = style;
        this.getFbData(options, style);
        const vdata = {
            type: 'register',
            name: 'sign-log',
            options: popReplace
                ? options
                : Object.assign(
                      {},
                      Data.registration,
                      { allowClose: true }, // 手动触发的均可关闭
                      options, // 可在options把allowClose覆盖掉
                      fromCmsOptions
                  )
        };

        try {
            signLog.isOpening = directOpen;
            let pop = await this.prepare(vm, style);
            var ins = popMgr.create(
                pop.default,
                vdata,
                'closeOtherPop',
                true,
                false
            );
            await util.sleep(350);
            ins.display(directOpen, false, true);
        } finally {
            signLog.isOpening = false;
        }
    }
};

window.signLog = signLog;

export const mixinsRegistry = _mixinsRegistry;

export default signLog;
